import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { LoaderComponent } from './loader/loader.component';
import { MasterTabListComponent } from './master-tab-list/master-tab-list/master-tab-list.component';
import { MasterTabComponent } from './master-tab/master-tab/master-tab.component';
import { NotResultFoundComponent } from './not-result-found/not-result-found.component';
import { MyFilterPipe } from './shared/pipes/my-filter.pipe';
import { StatusModalComponent } from './order/status-modal/status-modal.component';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MaterialModule } from './material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule, MatDialogModule } from '@angular/material';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { RedeemStatusModalComponent } from './redeem-status-modal/redeem-status-modal.component';
import { ImageModuleComponent } from './image-module/image-module.component';
import { OrderDetailComponent } from './order/order-detail/order-detail.component';
import { AgmCoreModule } from '@agm/core';
import { DistributionDetailComponent } from './distribution/distribution-detail/distribution-detail.component';
import { RouterModule } from '@angular/router';
import { RedeemRequestDetailComponent } from './redeem/redeem-request-detail/redeem-request-detail.component';
import { InfluencerDetailComponent } from './Influencer/influencer-detail/influencer-detail.component';
import { BillingDetailComponent } from './billing-detail/billing-detail.component';
// import { SalesReturnListComponent } from './sales-return/sales-return-list/sales-return-list.component';
import { CouponCodeAddComponent } from './coupon/coupon-code-add/coupon-code-add.component';
import { CouponCodeDetailComponent } from './coupon/coupon-code-detail/coupon-code-detail.component';
import { ReplacementComponent } from './coupon/replacement/replacement.component';

import { NgxBarcodeModule } from 'ngx-barcode';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { GatepassAddComponent } from './company-dispatch/gatepass-add/gatepass-add.component';
import { SecondaryOrderDetailComponent } from './order/secondary-order-detail/secondary-order-detail.component';
import { DesignationComponent } from './user/designation/designation.component';
import { AddDistributionComponent } from './distribution/add-distribution/add-distribution.component';
import { BottomSheetComponent } from './bottom-sheet/bottom-sheet.component';
import { AddGrandMasterBoxComponent } from './company-dispatch/add-grand-master-box/add-grand-master-box.component';
import { ViewMasterBoxDispatchDetailComponent } from './company-dispatch/view-master-box-dispatch-detail/view-master-box-dispatch-detail.component';
import { DistPrimaryOrderAddComponent } from './distribution/dist-primary-order-add/dist-primary-order-add.component';
import { CheckindocumentComponent } from './checkindocument/checkindocument.component';
import { AgmDirectionModule } from 'agm-direction';
import { DrComplaintAddComponent } from './distribution/dr-complaint/dr-complaint-add/dr-complaint-add.component';
import { DrComplaintDetailComponent } from './distribution/dr-complaint/dr-complaint-detail/dr-complaint-detail.component';
import { ChangeEnquiryStatusComponent } from './lead/change-enquiry-status/change-enquiry-status.component';
import { AttendanceDetailComponent } from './attendance-detail/attendance-detail.component';
import { LeadDetailComponent } from './lead/lead-detail/lead-detail.component';
import { SiteAddComponent } from './site/site-add/site-add.component';
import { SiteDetailComponent } from './site/site-detail/site-detail.component';
import { ZingchartAngularModule } from 'zingchart-angular';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TrackerComponent } from './attendence/tracker/tracker.component';
import { PlaybackComponent } from './attendence/playback/playback.component';
import { DistributorStockDetailComponent } from './distributor-stock/distributor-stock-detail/distributor-stock-detail.component';
import { CheckinViewComponent } from './checkin-view/checkin-view.component';
import { ContractorMeetStatusModalComponent } from './contractor-meet/contractor-meet-status-modal/contractor-meet-status-modal.component';
import { PinchZoomModule } from 'ngx-pinch-zoom';
import { LeaveMasterLedgerComponent } from './master/leave-master/leave-master-ledger/leave-master-ledger.component';
@NgModule({
  declarations: [
    DashboardComponent,
    NotResultFoundComponent,
    TrackerComponent,
    CheckinViewComponent,
    ChangeEnquiryStatusComponent,
    LoaderComponent,
    AddDistributionComponent,
    MyFilterPipe,
    MasterTabComponent,
    SiteAddComponent,
    SiteDetailComponent,
    MasterTabListComponent,
    StatusModalComponent,
    DesignationComponent,
    RedeemStatusModalComponent,
    ContractorMeetStatusModalComponent,
    ImageModuleComponent,
    DistributionDetailComponent,
    RedeemRequestDetailComponent,
    InfluencerDetailComponent,
    OrderDetailComponent,
    SecondaryOrderDetailComponent,
    DistPrimaryOrderAddComponent,
    DrComplaintAddComponent,
    DrComplaintDetailComponent,
    BillingDetailComponent,
    DistributorStockDetailComponent,
    CouponCodeAddComponent,
    // SalesReturnListComponent,
    GatepassAddComponent,
    LeadDetailComponent,
    CouponCodeDetailComponent,
    ReplacementComponent,
    BottomSheetComponent,
    AddGrandMasterBoxComponent,
    ViewMasterBoxDispatchDetailComponent,
    CheckindocumentComponent,
    AttendanceDetailComponent,
    LeaveMasterLedgerComponent,
    PlaybackComponent

  ],
  imports: [
    AgmCoreModule,
    ZingchartAngularModule,
    AgmDirectionModule,
    CommonModule,
    FilterPipeModule,
    PinchZoomModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule,
    MaterialModule,
    AutocompleteLibModule,
    MatIconModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
    NgxBarcodeModule,
    NgxQRCodeModule,
  ],
  exports: [
    NotResultFoundComponent,
    TrackerComponent,
    LoaderComponent,
    MyFilterPipe,
    FilterPipeModule,
    MasterTabComponent,
    MasterTabListComponent,
    DistributionDetailComponent,
    InfluencerDetailComponent,
    OrderDetailComponent,
  ],
  entryComponents: [StatusModalComponent, AttendanceDetailComponent, CheckinViewComponent, ChangeEnquiryStatusComponent, RedeemStatusModalComponent, CheckindocumentComponent, ImageModuleComponent, DesignationComponent, BottomSheetComponent, ContractorMeetStatusModalComponent]

})
export class AppUtilityModule { }
